<div class="login-footer">
  <img src="../../../assets/imgs/spi_logo_fav_icon.png" alt="spi-brand-logo" class="brand-footer-logo">
  <div class="login-footer-menu"> 
    <div class='refresh-window' (click)=" forceRefresh()" >
      <i class="fa fa-refresh" aria-hidden="true"></i>Force Refresh
    </div>
  <!--  <ul>
      <li class="menu">Contact us</li>
      <li class="menu">Privacy Policy</li>
    </ul>-->
  </div>
</div>
